import React, { Component } from 'react';
import { Slick } from './slick';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const viewportWidth = 1100;
const arrowGap = 100;

const SlickContainer = styled.div`
  text-align: center;
  margin: 40px auto 0 auto;
  @media (max-width: ${props => props.theme.breakpoints.lg}rem) {
    margin-top: 20px;
  }

  max-width: ${props => props.maxWidth}px;
  .slick-dots {
    position: relative !important;
    bottom: 0 !important;
    padding-top: 15px;
  }

  .slick-prev {
    left: ${props => (viewportWidth - props.edgeWidth) / 2 - arrowGap}px;
  }

  .slick-next {
    right: ${props => (viewportWidth - props.edgeWidth) / 2 - arrowGap}px;
  }

  .slick-slide,
  .carousel-item {
    display: inline-block;
    width: ${props =>
      props.itemWidth > 0
        ? props.itemWidth <= 1 ? `${props.itemWidth * 100}%` : `${props.itemWidth + props.gutter}px`
        : 'auto'};
    padding: 0 ${props => props.gutter / 2}px;
  }

  .carousel-item {
    vertical-align: top;
  }
`;

export class Carousel extends Component {
  static propTypes = {
    children: PropTypes.array,
    type: PropTypes.number,
    // type: 3, 4
    amount: PropTypes.number,
    // type: 3, 4
    itemWidth: PropTypes.number,
    // type: 1, 2
    gutter: PropTypes.number,
    amountSets: PropTypes.shape({
      edge: PropTypes.number,
      medium: PropTypes.number,
      small: PropTypes.number
    }),
    // type: 2
    arrow: PropTypes.bool,
    edgeWidth: PropTypes.number
  };

  static defaultProps = {
    type: 0,
    amount: 0,
    itemWidth: 0,
    gutter: 0,
    amountSets: {},
    arrow: false,
    edgeWidth: viewportWidth
  };

  state = {
    mounted: false
  };

  componentDidMount() {
    this.setState({ mounted: true });
    // fix slick center mode init position issue
    window.setTimeout(() => {
      try {
        this.slider.slickGoTo(0);
      } catch (e) {
        // sup...
      }
    }, 33);
  }

  render() {
    const { children, type, itemWidth, amount, gutter, amountSets, arrow } = this.props;

    let settings,
      itemGutter = gutter,
      itemFitWidth = itemWidth,
      containerMaxWidth = viewportWidth,
      placeholderAmount = 1;

    switch (type) {
      case 1:
        containerMaxWidth = viewportWidth + itemGutter;
        itemFitWidth = 1 / amountSets.edge;

        settings = {
          arrows: false,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 100000,
              settings: 'unslick'
            },
            {
              breakpoint: 768 + 1,
              settings: {
                slidesToShow: amountSets.medium,
                slidesToScroll: amountSets.medium
              }
            },
            {
              breakpoint: 640 + 1,
              settings: {
                slidesToShow: amountSets.small,
                slidesToScroll: amountSets.small
              }
            }
          ]
        };

        placeholderAmount = amountSets.edge;
        break;

      case 2:
        containerMaxWidth = viewportWidth + itemGutter;
        settings = {
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 100000,
              settings: {
                arrows: arrow,
                slidesToShow: amountSets.edge,
                slidesToScroll: amountSets.edge
              }
            },
            {
              breakpoint: 768 + 1,
              settings: {
                arrows: false,
                slidesToShow: amountSets.medium,
                slidesToScroll: amountSets.medium
              }
            },
            {
              breakpoint: 640 + 1,
              settings: {
                arrows: false,
                slidesToShow: amountSets.small,
                slidesToScroll: amountSets.small
              }
            }
          ]
        };

        placeholderAmount = amountSets.edge;
        break;

      case 3:
        if (amount % 2 === 0) {
          throw new Error('Carousel type 3 must have odd demand amount');
        }

        itemGutter = (viewportWidth - itemFitWidth * amount) / (amount - 1);
        containerMaxWidth = viewportWidth + itemGutter;

        settings = {
          arrows: false,
          infinite: true,
          dots: true,
          variableWidth: true,
          centerMode: true,
          centerPadding: 0,
          initialSlide: 1,
          responsive: [
            {
              breakpoint: 100000,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 640 + 1,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        };

        placeholderAmount = amount;
        break;

      case 4:
        itemGutter = (viewportWidth - itemFitWidth * amount) / (amount - 1);
        containerMaxWidth = viewportWidth + itemGutter;

        settings = {
          arrows: false,
          infinite: true,
          dots: true,
          variableWidth: true,
          centerMode: true,
          centerPadding: 0,
          initialSlide: 1,
          responsive: [
            { breakpoint: 100000, settings: 'unslick' },
            {
              breakpoint: containerMaxWidth,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 640 + 1,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        };

        placeholderAmount = amount;
        break;
    }

    return (
      <SlickContainer
        {...this.props}
        itemWidth={itemFitWidth}
        gutter={itemGutter}
        maxWidth={containerMaxWidth}
      >
        <Slick>
          {!this.state.mounted ? (
            <div>{children.slice(0, placeholderAmount)}</div>
          ) : (
            <Slider
              ref={slider => {
                this.slider = slider;
              }}
              {...settings}
            >
              {children}
            </Slider>
          )}
        </Slick>
      </SlickContainer>
    );
  }
}
